import axios from "axios";
import FeatherIcon from 'feather-icons-react';
import React, {Component} from "react";
import ReactToPrint from "react-to-print";
import Headerpdf from "../../users/Headerpdf";
import UserIdentity from "../../users/UserIdentity";


const createUniqueFilter = (key = 'id') => {
  const seen = new Set();
  return (item) => {
    const val = item?.[key];
    if (!val || seen.has(val)) return false;
    seen.add(val);
    return true;
  };
};

class SchoolfreeListMonth extends Component{

    state = {
        isModal : false,
        formData : null,
        loading : false,
        schoolfeecategoryId : null,
        sectionclassId : null,
        schoolfees : [],
        schoolfeecategories : [],
        months : [],
        monthId : null,
        mount_ : -1,
        collapsedClasses : {}
    }

    componentDidMount(){
        this.getMonths();
        this.getSchoolfreeCategories();
    }

    async getMonths(){
        var months = await axios.get("trimesters");
        if(months.status === 200)
        {
            this.setState({
                months : months.data
            })
        }
    }

    getSchoolfrees = async(schoolfeecategoryId = this.state.schoolfeecategoryId, monthId = this.state.monthId) =>{
        const resolvedSchoolfeecategoryId = schoolfeecategoryId || (localStorage.getItem("schoolfeecategoryId") ? JSON.parse(localStorage.getItem("schoolfeecategoryId")) : null);
        const resolvedMonthId = monthId || (localStorage.getItem("monthId") ? JSON.parse(localStorage.getItem("monthId")) : null);
        if(!resolvedSchoolfeecategoryId || !resolvedMonthId) return;

        this.setState({
            loading : false,
            schoolfeecategoryId : resolvedSchoolfeecategoryId,
            monthId : resolvedMonthId,
            collapsedClasses : {}
        })
        let schoolfees = await axios.get('/students/schoolfee__/' + resolvedMonthId +'/' + resolvedSchoolfeecategoryId)
        if(schoolfees.status === 200)
            this.setState({ schoolfees : schoolfees.data , loading : true })
    }

    handleInput = (e) => {
        const { name, value } = e.target;
        this.getSchoolfreeCategories(value);
        this.setState({
            [name]: value
        }, () => {
            if(name === "monthId" && value){
                this.getSchoolfrees(this.state.schoolfeecategoryId, value);
            }
        }); 
    }

    async getSchoolfreeCategories(){
        this.setState({schoolfeecategories : [] , loading : false}) 
        var schoolfeecategories = await axios.get('schoolfeecategories_/');
        if(schoolfeecategories.status === 200)
        {
            this.setState({schoolfeecategories : schoolfeecategories.data , loading : true}) 
        }
    }
    toggleClassRows = (sectionclassId) => {
        this.setState((state) => ({
            collapsedClasses : {
                ...state.collapsedClasses,
                [sectionclassId] : state.collapsedClasses[sectionclassId] !== false ? false : true
            }
        }))
    }
    
    render(){
        const isUniqueSectionClass = createUniqueFilter('id');
        const isUniqueSectionClass_ = createUniqueFilter('id');
        const isUniqueSectionClasss_ = createUniqueFilter('id');
        let student_ = 0, student__ =0, p1T = 0, v1T = 0, p2T = 0, v2T = 0, p3T = 0, v3T = 0, p4T = 0, v4T = 0; 
        const selectedCategory = this.state.schoolfeecategories?.filter(val => String(val.id) === String(this.state.schoolfeecategoryId))[0];
        const selectedMonth = this.state.months?.filter(val => String(val.id) === String(this.state.monthId))[0];
        const statusLabel = String(this.state.mount_) === "100" ? "Paiement 100%" : String(this.state.mount_) === "50" ? "Paiement 50%" : String(this.state.mount_) === "0" ? "Paiement 0%" : "Tous les paiements";
        const sectionCount = selectedCategory?.sectionschoolfeecategories?.reduce((total, sect) => total + (sect.section?.sectionclasses?.length || 0), 0) || 0;
        
        const sectionCount_ = selectedCategory?.sectionschoolfeecategories
        ?.flatMap(sect => sect.section?.sectionclasses || [])
        ?.filter(isUniqueSectionClass_)
        ?.length || 0;

        const activeCount = this.state.schoolfees?.filter(val => val?.status == 1)?.length || 0;
        const inactiveCount = this.state.schoolfees?.filter(val => val?.status == 0)?.length || 0;
        const title = "PAYEMENT GLOBAL " + (selectedCategory?.category || "") + " " + (selectedMonth?.short_trimester || "");
        
        return(
            <div className="finance-ledger-page schoolfee-recovery-page">
                <div className="finance-ledger-hero schoolfee-recovery-hero">
                    <div className="finance-ledger-hero__title">
                        <span className="ev-dashboard__eyebrow">Caisse scolaire</span>
                        <h1>Paiement global { selectedCategory?.category && <span>{ selectedCategory.category }</span>}</h1>
                        <p>{ selectedMonth?.short_trimester ? `${selectedMonth.short_trimester} - ${statusLabel}` : "Choisissez un frais et une echeance pour afficher les paiements." }</p>
                    </div>

                    <div className="finance-ledger-hero__actions schoolfee-recovery-filters">
                        <label className="finance-ledger-select">
                            <FeatherIcon icon="credit-card" size="16" />
                            <select name="schoolfeecategoryId" value={ this.state.schoolfeecategoryId || "" } onChange={this.handleInput}>
                                <option value={ "" }>selectionner frais </option>
                                {
                                    this.state.schoolfeecategories.map((schoolfeecategory) => {
                                        if(schoolfeecategory.sectionschoolfeecategories?.filter(va => va.transport?.id != null)?.length == 0)
                                            return(<option key={schoolfeecategory.id} value={schoolfeecategory.id}>{ schoolfeecategory.category }</option>)
                                    })
                                }
                            </select>
                        </label>
                        <label className="finance-ledger-select">
                            <FeatherIcon icon="calendar" size="16" />
                            <select name="monthId" value={ this.state.monthId || "" } onChange={this.handleInput}>
                                <option value={ "" }>selectionner </option>
                                {
                                    this.state.months.map((trimester) => {
                                        return(
                                            <option key={ trimester.id } value={ trimester.id }>{ trimester.short_trimester }</option>
                                        )
                                    })
                                }
                            </select>
                        </label>
                        <label className="finance-ledger-select">
                            <FeatherIcon icon="filter" size="16" />
                            <select name="mount_" value={ this.state.mount_} onChange={this.handleInput}>
                                <option value={ -1 }>Tout paiement</option>
                                <option value={ 100 }>Paiement 100%</option>
                                <option value={ 50 }>Paiement 50% </option>
                                <option value={ 0 }>Paiement 0% </option>
                            </select>
                        </label>
                        <button type="button" className="btn btn-sm btn-outline-primary finance-ledger-print" onClick={() => this.getSchoolfrees()}>
                            <FeatherIcon icon="server" size="17" /> <span>Afficher</span>
                        </button>
                        <ReactToPrint
                            trigger={() => <button className="btn btn-sm btn-outline-primary finance-ledger-print" type="button"><FeatherIcon icon={"printer"} size="17" /> <span>Imprimer</span></button>}
                            content={() =>  this.componentRef}
                        />
                    </div>
                </div>

                <div className="finance-ledger-stats schoolfee-recovery-stats">
                    <article><span><FeatherIcon icon="users" size="17" /></span><div><strong>{this.state.schoolfees?.length || 0}</strong><small>Eleves</small></div></article>
                    <article><span><FeatherIcon icon="grid" size="17" /></span><div><strong>{sectionCount_}</strong><small>Classes</small></div></article>
                    <article><span><FeatherIcon icon="check-circle" size="17" /></span><div><strong>{activeCount}</strong><small>Actifs</small></div></article>
                    <article><span><FeatherIcon icon="alert-circle" size="17" /></span><div><strong>{inactiveCount}</strong><small>Abandons</small></div></article>
                </div>

                <section className="finance-ledger-panel schoolfee-recovery-panel">
                    <div className="finance-ledger-panel__header">
                        <div>
                            <span>Liste des paiements</span>
                            <h2>{ selectedCategory?.category || "Aucun frais selectionne" } { selectedMonth?.short_trimester || "" }</h2>
                        </div>
                        <b>{this.state.loading ? `${this.state.schoolfees?.length || 0} ligne(s)` : "Chargement..."}</b>
                    </div>
                    <div ref={el => (this.componentRef = el)}>
                        <Headerpdf />
                        <UserIdentity title={title} />
                        <div className="table-responsive finance-ledger-table-wrap schoolfee-recovery-table-wrap">
                            <table className="table table-sm finance-ledger-table schoolfee-recovery-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th scope="col">Eleve</th>
                                        <th>Montant</th>
                                    </tr>
                                </thead>
                                
                                <tbody>
                                    { !this.state.loading && (<tr><td colSpan={3} className="finance-ledger-state"><FeatherIcon className="user-search-spin" icon="loader" /> Chargement des paiements...</td></tr>)}
                                    { this.state.loading && this.state.schoolfees?.length === 0 && (<tr><td colSpan={3} className="finance-ledger-state">Selectionnez un frais et une echeance pour afficher les paiements.</td></tr>)}
                                {
                                    this.state.schoolfeecategories.filter(val => val.id == this.state.schoolfeecategoryId && this.state.schoolfees?.length > 0 ).map((schoolfeecategory) => {
                                        return(
                                            schoolfeecategory.sectionschoolfeecategories?.map( sect => {
                                                return(
                                                    // sect.section?.sectionclasses?.sort((a, b) => a.class?.short_entitled_class > b.class?.short_entitled_class ? 1 : -1)?.map(sectionclass =>{
                                                    sect.section?.sectionclasses
                                                    ?.filter(isUniqueSectionClasss_)
                                                    ?.slice()
                                                    ?.sort((a, b) => (a.class?.short_entitled_class ?? '').localeCompare(b.class?.short_entitled_class ?? ''))
                                                    ?.map((sectionclass) => {
                                                        let count_ = 0
                                                        let coun__ = 0, coun_ = 0
                                                        const isClassCollapsed = this.state.collapsedClasses[sectionclass.id] !== false;
                                                        return(
                                                            <>
                                                                <tr key={sectionclass.id} className="finance-ledger-date-row schoolfee-recovery-class-toggle" onClick={() => this.toggleClassRows(sectionclass.id)} onKeyDown={(e) => { if(e.key === "Enter" || e.key === " "){ e.preventDefault(); this.toggleClassRows(sectionclass.id) } }} role="button" tabIndex={0} title={isClassCollapsed ? "Afficher la liste" : "Cacher la liste"}>
                                                                    <td align="center" colSpan={3}><span className="finance-ledger-date schoolfee-recovery-class-label"><FeatherIcon icon={isClassCollapsed ? "chevron-right" : "chevron-down"} size="14" /> { sectionclass.class?.short_entitled_class } { sectionclass.title } { sect.section?.entitled_section }</span></td>
                                                                </tr>
                                                                {
                                                                    this.state.schoolfees?.filter(val => val?.sectionclassId == sectionclass?.id).sort((a, b) => a.user?.last_name + ' ' + a.user?.family_name + ' ' + a.user?.first_name > b.user?.last_name + ' ' + b.user?.family_name + ' ' + b.user?.first_name ? 1 : -1).map((student) => {
                                                                        let mount = 0, cdf = 0
                                                                        
                                                                        student.schoolfees?.filter(val => val.trimesectschool?.trimester?.short_trimester == selectedMonth?.short_trimester && val.sectionschoolfeecategory?.currency == "USD")?.map((schoolfree) => {
                                                                            mount += schoolfree.pay_mount
                                                                            sect.price = schoolfree.trimesectschool?.price
                                                                        })

                                                                        student.schoolfees?.filter(val => val.trimesectschool?.trimester?.short_trimester == selectedMonth?.short_trimester && val.sectionschoolfeecategory?.currency == "CDF")?.map((schoolfree) => {
                                                                            cdf += schoolfree.pay_mount
                                                                            sect.price = schoolfree.trimesectschool?.price
                                                                        })
                                                                        
                                                                        if((this.state.mount_ == 100 && sect?.price == mount) || (this.state.mount_ == 0 && 0 == mount) || (this.state.mount_ == 50 && parseFloat(sect?.price || 0)/2 == mount) || this.state.mount_ == -1 ){
                                                                            student_ += mount
                                                                            student__ += cdf
                                                                            coun_ += mount
                                                                            coun__ += cdf
                                                                            return(
                                                                                <tr key={student.id} style={{ display : isClassCollapsed ? "none" : undefined }}>
                                                                                    <td>{ count_ += 1}</td>
                                                                                    <td><span className="finance-ledger-account">{ student?.user?.last_name } { student?.user?.family_name } { student?.user?.first_name } { student.status == 1 ? <span className="badge text-primary alert-primary" >Actif</span> : <span className={ student.status == 0 ? "badge text-danger alert-danger" : "badge text-warning alert-warning"} > { student.status == 0 ? "Abandon" : "Non actif" }</span> }</span></td>
                                                                                    <td className="finance-ledger-money">{ mount > 0 ? mount?.toLocaleString() : '' } { cdf > 0 ? cdf?.toLocaleString() : '' } </td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                    })
                                                                }
                                                                <tr key={sectionclass.id+'1'} className="schoolfee-recovery-total-row">
                                                                    <th></th>
                                                                    <th>Total classe</th>
                                                                    <th>{ coun_ > 0 ? coun_?.toLocaleString() : '' } { coun__ > 0 ? coun__?.toLocaleString() : '' } </th>
                                                                </tr>
                                                            
                                                            </>
                                                        )
                                                    })
                                                )
                                            })
                                        )
                                    })
                                }
                                    
                                    <tr className="schoolfee-recovery-total-row">
                                        <th colSpan={2}>Total general</th>
                                        <th>{ student_ > 0 ? student_?.toLocaleString() : '' } { student__ > 0 ? student__?.toLocaleString() : '' }</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
                
                <section className="finance-ledger-panel schoolfee-recovery-panel">
                    <div className="finance-ledger-panel__header">
                        <div>
                            <span>Synthese</span>
                            <h2>{ selectedCategory?.category || "Aucun frais selectionne" } { selectedMonth?.short_trimester || "" }</h2>
                        </div>
                        <ReactToPrint
                            trigger={() => <button className="btn btn-sm btn-outline-primary finance-ledger-print" type="button"><FeatherIcon icon={"printer"} size="17" /> <span>Imprimer</span></button>}
                            content={() =>  this.componentRef2}
                        />
                    </div>
                    <div ref={el => (this.componentRef2 = el)}>
                        <Headerpdf />
                        <UserIdentity title={title} />
                        <div className="table-responsive finance-ledger-table-wrap schoolfee-recovery-table-wrap">
                            <table className="table table-sm finance-ledger-table schoolfee-recovery-table">
                                <thead>
                                    <tr>
                                        <th style={{ width : "12%"}}>Classe</th>
                                        <th scope="col">Actif</th>
                                        <th>Abandon</th>
                                        <th>100%</th>
                                        <th>50%</th>
                                        <th>0 %</th>
                                        <th>Autres %</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.schoolfeecategories.filter(val => val.id == this.state.schoolfeecategoryId && this.state.schoolfees?.length > 0 ).map((schoolfeecategory) => {
                                            return(
                                                schoolfeecategory.sectionschoolfeecategories?.map( sect => (
                                                    sect.transport ? <option value={ sect.transport?.id}>{ sect.transport?.axe }</option> :
                                                    // sect.section?.sectionclasses?.sort((a, b) => a.class?.short_entitled_class > b.class?.short_entitled_class ? 1 : -1)?.map(sectionclass =>{
                                                    sect.section?.sectionclasses
                                                    ?.filter(isUniqueSectionClass)
                                                    ?.slice()
                                                    ?.sort((a, b) => (a.class?.short_entitled_class ?? '').localeCompare(b.class?.short_entitled_class ?? ''))
                                                    ?.map((sectionclass) => {
                                                        let  p1 = 0, v1 = 0, p2 = 0, v2 = 0, p3 = 0, v3 = 0, p4 = 0, v4 = 0
                                                        this.state.schoolfees?.filter(v_ => v_.sectionclassId == sectionclass.id)?.sort((a, b) => a.user?.last_name + ' ' + a.user?.family_name + ' ' + a.user?.first_name > b.user?.last_name + ' ' + b.user?.family_name + ' ' + b.user?.first_name ? 1 : -1).map((student) => {
                                                            let mount = 0
                                                        
                                                            student.schoolfees?.filter(val => val.trimesectschool?.trimester?.short_trimester == selectedMonth?.short_trimester && val.sectionschoolfeecategory?.currency == sect.currency)?.map((schoolfree) => {
                                                                mount += schoolfree.pay_mount
                                                                sect.price = schoolfree.trimesectschool?.price
                                                            })
                                                            if(mount == sect.price){
                                                                p1 +=1
                                                                v1 += parseFloat(mount || 0)
                                                                p1T += 1
                                                                v1T += parseFloat(mount || 0)
                                                            }
                                                            else if(mount == (parseFloat(sect.price || 0) / 2)){
                                                                p2 += 1
                                                                v2 += parseFloat(mount || 0)
                                                                p2T += 1
                                                                v2T += parseFloat(mount || 0)
                                                            }
                                                            else if (mount == 0){
                                                                p3 += 1
                                                                v3 += parseFloat(mount || 0)
                                                                p3T += 1
                                                                v3T += parseFloat(mount || 0)
                                                            }
                                                            else if (mount > 0 ){
                                                                p4 += 1
                                                                v4 += parseFloat(mount || 0)
                                                                p4T += 1
                                                                v4T += parseFloat(mount || 0)
                                                            }
                                                        })
                                                        return (
                                                            <>
                                                                <tr>
                                                                    <td rowSpan={2}><span className="finance-ledger-account">{ sectionclass.class?.short_entitled_class } { sectionclass.title } { sect.section?.short_entitled_section }</span></td>
                                                                    <td rowSpan={2}>{ this.state.schoolfees?.filter(val => val?.status == 1 && val.sectionclassId == sectionclass.id)?.length }</td>
                                                                    <td rowSpan={2}>{ this.state.schoolfees?.filter(val => val?.status == 0 && val.sectionclassId == sectionclass.id)?.length }</td>
                                                                    <td className="finance-ledger-money">{ p1?.toLocaleString() }</td>
                                                                    <td className="finance-ledger-money">{ p2?.toLocaleString() }</td>
                                                                    <td className="finance-ledger-money">{ p3?.toLocaleString() }</td>
                                                                    <td className="finance-ledger-money">{ p4?.toLocaleString() }</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="finance-ledger-money">{ v1?.toLocaleString() } </td>
                                                                    <td className="finance-ledger-money">{ v2?.toLocaleString() }</td>
                                                                    <td className="finance-ledger-money">{ v3?.toLocaleString() }</td>
                                                                    <td className="finance-ledger-money">{ v4?.toLocaleString() }</td>
                                                                </tr>
                                                            </>
                                                        )
                                                    })
                                                ))
                                            )
                                        })
                                    }
                                    

                                    <tr className="schoolfee-recovery-total-row">
                                        <th>Effectif </th>
                                        <th>{ this.state.schoolfees?.filter(val => val?.status == 1)?.length }</th>
                                        <th>{ this.state.schoolfees?.filter(val => val?.status == 0)?.length }</th>
                                        <th>{ p1T.toLocaleString() }</th>
                                        <th>{ p2T.toLocaleString() }</th>
                                        <th>{ p3T.toLocaleString() }</th>
                                        <th>{ p4T.toLocaleString() }</th>
                                    </tr>
                                    <tr className="schoolfee-recovery-total-row">
                                        <th colSpan={3}>Total montant</th>
                                        <th>{ v1T.toLocaleString() }</th>
                                        <th>{ v2T.toLocaleString() }</th>
                                        <th>{ v3T.toLocaleString() }</th>
                                        <th>{ v4T.toLocaleString() }</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
export default SchoolfreeListMonth;
